import { useCallback } from "react";
import useWeb3 from "../hooks/useWeb3";
import environment from "../utils/Enviroment";
import { getdopTokenContract } from "../utils/contractHelpers";

export const GetBalance = () => {
  const web3 = useWeb3();
  const tokenAddress = environment?.Doptoken;
  const contract = getdopTokenContract(tokenAddress, web3);
  const GetBal = useCallback(async (account) => {
    const approved = await contract.methods.balanceOf(account).call();
    // let balance = web3.utils.fromWei(approved, "ether")
    let balance = parseInt(approved) / 1000000000000000000
    // console.log("balance", balance)
    return balance;
  }, [contract]);

  return { GetBal: GetBal };
};

export default GetBalance;